import Validator from './validator.js';

export default class MatchingValidator extends Validator {
    constructor(input) {
        super(input);
        this.field = this.input.parent;
        this.form = this.field.parent;
        this.compareTo = this.input.el.dataset.compareTo;
        this.compareEl = this.form.el.querySelector(`[name="${this.compareTo}"]`);
    }

    valid() {
        return this.compareEl ? this.input.el.value === this.compareEl.value : false;
    }

    static applies(input) {
        return input.el.dataset.compareTo !== undefined;
    }
}
